/**
 * Redux action type constants for Salesforce (SF) operations.
 *
 * Defines all action types used in the Salesforce Redux reducer and actions
 * for managing case data, API requests, and data loading states.
 *
 * @module sfTypes
 * @author Snowfly
 * @version 1.0.0
 */
export const FETCH_REQUEST_SF = 'FETCH_REQUEST_SF';
export const FETCH_FAILURE_SF = 'FETCH_FAILURE_SF';
export const FETCH_ALL_CASE_ID = 'FETCH_ALL_CASE_ID';
export const FETCH_CASE_DETAILS = 'FETCH_CASE_DETAILS';
export const FETCH_FAILURE_SF_CASEIDS = 'FETCH_FAILURE_SF_CASEIDS';
export const FETCH_CASE_CALLER_SUCCESS = 'FETCH_CASE_CALLER_SUCCESS';
export const FETCH_CASE_HISTORY = 'FETCH_CASE_HISTORY';
export const SF_RESET = 'SF_RESET';
export const SF_DATA_LOADED = 'SF_DATA_LOADED';
